import { FunctionButton } from '@pulse-web-ui/button-v2';
import { styled } from '@pulse-web-ui/theme';

export const Button = styled(FunctionButton)`
  margin-bottom: 16px;
`;
